import './WebTraderSection.css';
import img1 from '../assets/tradexviedoPic1.avif';
import img2 from '../assets/tradexviedoPic2.avif';
import img3 from '../assets/tradexviedoPic3.avif';
import img4 from '../assets/tradexviedoPic4.avif';

const sliderData = [
  { id: 1, image:img1  },
  { id: 2, image: img2 },
  { id: 3, image: img3},
  { id: 4, image: img4 }
];

const WebTraderSection = () => {
  return (
    <section className="web-trader">
      <p className="web-trader-subtitle">
        Best Web Trading Platform. Trade Smart. Trade Bold
      </p>

      <h2 className="web-trader-title">
        Initiate Smart Web Trading
      </h2>

      <button className="web-trader-btn">
        🌐 Web Trader
      </button>

      <div className="web-trader-slider">
        {sliderData.map(item => (
          <div key={item.id} className="slider-card">
            <img src={item.image} alt="Trading" />
          </div>
        ))}
      </div>

      <div className="slider-dots">
        <span className="dot active"></span>
        <span className="dot"></span>
        <span className="dot"></span>
        <span className="dot"></span>
      </div>
    </section>
  );
};

export default WebTraderSection;
